import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { KinesisVideoStreamContext } from '../Context/KinesisVideoStreamContext';
import { useFragmentList } from './useFragmentList';
import { FragmentTable } from './FragmentTable';
export const useFragmentTable = ({}) => {
    const { state } = useContext(KinesisVideoStreamContext);
    const { kvaClient, selectedStreamInfo } = state;
    const { Fragments } = useFragmentList({});
    const fragmentTable = kvaClient ? _jsx(FragmentTable, { Fragments: Fragments ?? [], client: kvaClient, StreamARN: selectedStreamInfo?.StreamARN ?? '' }) : null;
    return {
        isLive: state.isLive,
        fragmentTable,
    };
};
